import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContainerComponent } from '../../layout/container/container.component';
import { BannerComponent } from '../../common/banner/banner.component';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-products-hero',
  standalone: true,
  imports: [CommonModule, ContainerComponent, BannerComponent],
  templateUrl: './products-hero.component.html',
  styleUrls: ['./products-hero.component.scss']
})
export class ProductsHeroComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('productsHero', { static: false }) productsHero?: ElementRef;

  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit() {
    // No necesita tracking de página aquí, se maneja en la página padre
  }

  ngAfterViewInit() {
    // Registrar la sección para tracking de analytics
    if (this.productsHero?.nativeElement) {
      this.analyticsService.registerSectionForTracking(
        this.productsHero.nativeElement,
        'Products Hero',
        'products-hero-section'
      );
    }
  }

  ngOnDestroy() {
    // Cleanup si es necesario
  }
}
